import { z } from 'zod';
import { timezones } from '../timezones';
import {
  MAX_USERNAME_LENGTH,
  MAX_USER_PASSWORD_LENGTH,
  MIN_USER_PASSWORD_LENGTH,
} from './secureUserSchemas';

/**
 * @deprecated NIM-19044 password complexity is increased
 * new implementation has been moved to ./secureUserSchemas.ts
 * this implmementation can be used only for logging in or legacy implementations
 * until they are updated to use the secure implementation
 */
export const userSchemas = {
  timezone: z.enum(timezones),
  password: z
    .string()
    .min(MIN_USER_PASSWORD_LENGTH)
    .max(MAX_USER_PASSWORD_LENGTH),
  username: z
    .string()
    .min(1)
    .regex(/^[a-zA-Z0-9_\-.@]+$/)
    .max(MAX_USERNAME_LENGTH),
  roleIds: z.array(z.string()),
};
